import styled from 'styled-components';

export const Row = styled.div`
  margin-top: 24px;
  padding: 0 20px;
  border-bottom: 5px solid #e9edf0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const DatePickerWrapper = styled.div`
  .manual-alerts-date-picker {
    min-width: unset;
    width: fit-content;
  }
`;
